import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { SvgLicenseDriver, SvgLicenseCpr } from 'components/Svg'

import styles from './styles.css'

class UserSkills extends Component {
  static propTypes = {
    className: PropTypes.string,
    driver: PropTypes.bool,
    cpr: PropTypes.bool,
  }

  static defaultProps = {
    className: '',
    driver: false,
    cpr: false,
  }

  getClassName() {
    return classnames(styles.root, this.props.className)
  }

  render() {
    return (
      <div className={this.getClassName()}>
        {this.props.driver && (
          <div className={styles.skill}>
            <SvgLicenseDriver
              className={styles.skillIcon}
              style={{ fill: '#2566b8' }}
            />
            <span className={styles.skillName}>B-körkort</span>
          </div>
        )}

        {this.props.cpr && (
          <div className={styles.skill}>
            <SvgLicenseCpr
              className={styles.skillIcon}
              style={{ fill: '#ff563b' }}
            />
            <span className={styles.skillName}>HLR-utbildad</span>
          </div>
        )}
      </div>
    )
  }
}

export default UserSkills



// WEBPACK FOOTER //
// ../source/components/UserSkills/index.js